export class StopHaversineDistance{
    constructor(lat,lon){
        this.lat = lat;
        this.lon = lon;
    }

    // ==========
    // private 
    // ----------

    getLat(){ return this.lat }
    getLon(){ return this.lon }



    computeHaversineDistance(stop){
        var lat1 = this.getLat();
        var lon1 = this.getLon();
        var [lat2,lon2] = stop.getLatLon();
        return Utils.computeHaversineDistance(lat1, lon1, lat2 ,lon2)
    }

    checkParam(stop){
        return ((this.getLat() && this.getLon()) || stop.getLatLon() )
    }


    // ===========
    // public 
    // ----------

    setLat(l){ this.lat = l }
    setLon(l){ this.lon = l }

    setCenter(lat,lon){
        this.lat = lat;
        this.lon = lon;
    }

    compute(itemArray){
        return itemArray.map(item=>{
            // var destination = item.getSchoolStation();
            if (this.checkParam(item)){
                item.haversine = this.computeHaversineDistance(item);
                return item;
            }
        })
    }


    
}


var processAll = (fn)=>{
        return (dataArray)=>dataArray.map(data => fn(data))
}

// [d1,d2, ..] -> [ fn(d1), dn(d2), ...]
var processAll2 = (...fn)=>{
    return (dataArray)=>{

    }
}

class Utils{
    //===========
    // static
    // -----------
    static computeHaversineDistance(lat1, lon1, lat2 ,lon2){
        var dLat = Utils.toRadians(lat2 - lat1);
        var dLon = Utils.toRadians(lon2 - lon1) * Math.cos(Utils.toRadians((lat1+lat2) / 2));
        return Utils.EARTH_RADIUS * Math.sqrt(dLat * dLat + dLon * dLon)
    }

    static toRadians(deg){
        return deg * Math.PI / 180
    }

    static EARTH_RADIUS = 6371 * 1000;
}


export class StopHaversineDistanceOptions{
    constructor(){

    }
    set center(c){  // mandatory parameter
        this._center = c
    }
    get center(){ return this._center }
}